var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameover05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 161.36 154.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill-rule:evenodd;}.cls-2{fill:url(#New_Gradient_Swatch_92);}.cls-3{fill:url(#New_Gradient_Swatch_91);}.cls-4,.cls-7{mix-blend-mode:screen;}.cls-4{fill:url(#radial-gradient);}.cls-5{fill:#fff;opacity:0.75;}.cls-6{fill:#683c11;opacity:0.5;mix-blend-mode:multiply;}.cls-7{fill:#ca9e67;opacity:0.65;}.cls-8{fill:url(#radial-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_92",
    x1: 80.73,
    y1: 127.61,
    x2: 80.73,
    y2: 25.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#692705"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823b00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_91",
    cx: 29.25,
    cy: 19.24,
    r: 141.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f59547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a14c1f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 25.72,
    cy: 12.37,
    r: 110.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a48a7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945534"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 64.3,
    cy: 45.16,
    r: 81.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d90000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.08,26.29c8.82-1.8,95.34-1.43,101.61,0,1.23,4,1.23,96.27,0,99.94-7,2.07-91.38,1.59-101.61,0-1.77-4.43-1.52-93.54,0-99.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.08,20.14c8.82-1.8,95.34-1.43,101.61,0,1.23,4,1.23,96.27,0,99.93-7,2.08-91.38,1.6-101.61,0-1.77-4.42-1.52-93.54,0-99.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.12,22.25c1.29.15,2.95.41,3.69,1.47a17.08,17.08,0,0,1,1.36,3.93,57.62,57.62,0,0,0-.48-7.51c-6.27-1.43-92.79-1.8-101.61,0-.53,2.22-.9,14.41-1.09,29.56a157.48,157.48,0,0,1,4-23.54c.25-.94.79-2.24,1.76-2.34,27.75-3,64.39-4.7,92.41-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.81,30.91c-2.75-.1-5.5-.16-8.25-.22q-15.93-.33-31.88-.32c-10.5,0-21,0-31.5.25-2.78.06-5.57.12-8.35.22q-.13,4.05-.22,8.1c-.22,10.36-.3,20.73-.32,31.09s0,20.61.23,30.91c0,2.79.11,5.59.21,8.38,2.74.11,5.5.19,8.25.26,10.54.27,21.11.39,31.66.42s21,0,31.44-.22c2.91-.07,5.82-.14,8.73-.26.07-2.71.12-5.41.16-8.12.16-10.43.2-20.87.2-31.3s0-20.87-.2-31.3c0-2.63-.09-5.26-.16-7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.88,34.22c0-1.1,0-2.21-.07-3.31-2.75-.1-5.5-.16-8.25-.22q-15.93-.33-31.88-.32c-10.5,0-21,0-31.5.25-2.78.06-5.57.12-8.35.22,0,1.13-.07,2.25-.11,3.38,25.21-3.82,62-2.78,80.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M112.08,109.78c-10.47.22-21,.26-31.44.22s-21.12-.15-31.66-.42c-2.75-.07-5.51-.15-8.25-.26,2.63,2.75,76.38,3.46,80.08.2-2.91.12-5.82.19-8.73.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M97.66,43.18A52.33,52.33,0,0,1,110,55.56c-4.16,4.88-9.59,10.77-15.5,16.87,5.63,5.83,11,11.68,15.43,16.93a52.15,52.15,0,0,1-12.38,12.38c-4.87-4.16-10.77-9.59-16.87-15.5-6,5.8-11.87,11.22-16.86,15.5A52.16,52.16,0,0,1,51.48,89.36c3.86-4.57,9.32-10.55,15.46-16.92-5.81-6-11.24-11.88-15.52-16.88A52.16,52.16,0,0,1,63.8,43.18C68.36,47,74.34,52.5,80.71,58.63c5.83-5.64,11.69-11,17-15.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameover05);
export default __webpack_public_path__ + "static/media/game over-05.2ad4b89b5f657a8b8f7f3ba9afe57073.svg";
export { ForwardRef as ReactComponent };